import axios from "axios";
import config from "./config";

type getByParams = {
    filter?: {},
    sort?: {},
    page?: number
}

const ContentApi = {

    get: async (id: number) => {
        try {
            const response = await axios.get(config.host + '/api/content/' + id);
            return response.data;
        } catch (error) {
            throw new Error('Unable to get content: ' + id);
        }
    },

    getBy: async ({filter, sort = {id: 'desc'}, page = 1} : getByParams) => {
        try {
            const response = await axios.post(config.host + '/api/content', JSON.stringify({
                filter: filter,
                sort: sort,
                page: page
            }));
            return response.data;
        } catch (error) {
            throw new Error('Unable to get content');
        }
    }
}

export default ContentApi;
